import { DeskPricesDTO } from "@raskrask-dk/raskrask-utils";


export const mapGetPricesByProfileId = (prices: DeskPricesDTO[]): DeskPricesDTO[] => {
  return prices.map((p) => {
    return {
      serviceTypeId: p.serviceTypeId,
      serviceTypeName: p.serviceTypeName,
      defaultPrice: p.defaultPrice,
      isSetByPartner: p.isSetByPartner,
      setPrice: p.setPrice,
    };
  });
};
